import React from 'react'
import "../App.css"
import { Link } from 'react-router-dom'

const Privacy = () => {
    return (
        <div className='privacy-page'>
            <Link to={"/"}>
            <p>Back</p>
            </Link>
            <div className="privacy-policy">
                <h1>Onnize Privacy Policy</h1>
                <p><strong>Effective Date:</strong> 21/2/2025</p>

                <p>Welcome to <strong>Onnize</strong>! Your privacy is important to us, and we are committed to protecting your personal information. This Privacy Policy describes how <strong>Onnize Company Ltd</strong> ("we," "us," or "our") collects, uses, and shares your information when you use our social media platform, <strong>Onnize</strong> (the "Service").</p>

                <p>We encourage you to read this policy carefully to understand how we handle your data.</p>

                <h2>1. Information We Collect</h2>

                <h3>1.1 Information You Provide Directly</h3>
                <ul>
                    <li><strong>Account Information:</strong> When you create an account, you provide us with information such as your name, email address, username, password, date of birth, and profile picture. You may also choose to provide additional details such as location, interests, and bio.</li>
                    <li><strong>Content & Posts:</strong> You may share content on the Service, including text, photos, videos, and comments. This content will be associated with your account and may be visible to others based on your privacy settings.</li>
                    <li><strong>Communications:</strong> When you interact with other users, organizations, or customer support, we collect information about those interactions, including messages and participants.</li>
                    <li><strong>Optional Features:</strong> We may offer surveys, contests, or other features that require additional information from you.</li>
                </ul>

                <h3>1.2 Information We Collect Automatically</h3>
                <ul>
                    <li><strong>Usage Information:</strong> We track how you use the Service, such as pages visited, features used, and time spent on the platform.</li>
                    <li><strong>Device Information:</strong> We collect details about your device, including IP address, browser type, operating system, and device identifiers.</li>
                    <li><strong>Location Information:</strong> With your permission, we may collect location data to enhance your experience.</li>
                    <li><strong>Cookies & Tracking Technologies:</strong> We use cookies and similar technologies to personalize your experience and improve our services.</li>
                </ul>

                <h3>1.3 Information from Third Parties</h3>
                <p>We may receive additional information about you from other users, third-party partners, or publicly available sources.</p>

                <h2>2. How We Use Your Information</h2>
                <ul>
                    <li>✅ <strong>Providing & Improving the Service</strong> – To operate, personalize, and enhance the user experience.</li>
                    <li>✅ <strong>Communication</strong> – To send notifications, updates, and respond to inquiries.</li>
                    <li>✅ <strong>User & Organization Interactions</strong> – To connect users with organizations, suggest content, and improve engagement.</li>
                    <li>✅ <strong>Research & Analytics</strong> – To understand how users interact with the platform and improve services.</li>
                    <li>✅ <strong>Legal Compliance</strong> – To meet legal requirements and enforce our terms.</li>
                    <li>✅ <strong>Advertising & Marketing</strong> – To show relevant ads on <strong>Onnize</strong> and partner platforms (you can control ad preferences in settings).</li>
                </ul>

                <h2>3. How We Share Your Information</h2>
                <p>We do not sell your personal information. However, we may share your data with:</p>
                <ul>
                    <li><strong>Other Users:</strong> Your profile and content may be visible based on your privacy settings.</li>
                    <li><strong>Service Providers:</strong> We work with trusted third-party vendors for hosting, analytics, and advertising.</li>
                    <li><strong>Legal Authorities:</strong> When required by law or to protect users and the platform.</li>
                    <li><strong>Business Transfers:</strong> In case of mergers, acquisitions, or asset sales, your data may be transferred.</li>
                </ul>

                <h2>4. Your Choices</h2>
                <ul>
                    <li>✔ <strong>Privacy Settings:</strong> Customize who can see your posts and profile information.</li>
                    <li>✔ <strong>Ad Preferences:</strong> Manage ad personalization settings.</li>
                    <li>✔ <strong>Cookies:</strong> Control tracking preferences through your browser settings.</li>
                    <li>✔ <strong>Account Deletion:</strong> You can request account deletion at any time. Some data may be retained for legal or operational purposes.</li>
                </ul>

                <h2>5. Children's Privacy</h2>
                <p>Our Service is not intended for children under the age of 12. We do not knowingly collect personal information from children. If you believe a child has provided us with personal data, please contact us.</p>

                <h2>6. Data Security & Retention</h2>
                <p>We implement industry-standard security measures to protect your data. However, no system is 100% secure. We retain your information as long as necessary to provide our services and comply with legal obligations.</p>

                <h2>7. International Data Transfers</h2>
                <p>If you access <strong>Onnize</strong> from outside Kenya, your information may be transferred and processed in other regions with different data protection laws.</p>

                <h2>8. Changes to This Privacy Policy</h2>
                <p>We may update this Privacy Policy from time to time. We will notify you of significant changes by posting updates on <strong>Onnize</strong> or sending an alert.</p>

                <h2>9. Contact Us</h2>
                <p>If you have any questions about this Privacy Policy, contact us at:</p>
                <ul>
                    <li>📧 <strong>Email:</strong><a href="email:info@onnize.com">care@onnize.com</a></li>
                    <li>📍 <strong>Address:</strong>onnization center,nakuru,kenya </li>
                    <li>🌐 <strong>Website:</strong><a href="https://company.onnize.com" target='_blank'> company.onnize.com</a></li>
                </ul>

                <p>By using <strong>Onnize</strong>, you agree to this Privacy Policy. If you do not agree, please do not use our platform.</p>
            </div>

        </div>
    )
}

export default Privacy